import { useEffect } from 'react';
import { getStorefrontFaviconUrl } from '../../utils/storefrontBrand';

const GOOGLE_FAVICON = `${process.env.PUBLIC_URL || ''}/favicon-48.png`;

const upsertIcon = (selector, attrs) => {
  let link = document.head.querySelector(selector);
  if (!link) {
    link = document.createElement('link');
    document.head.appendChild(link);
  }
  Object.entries(attrs).forEach(([key, value]) => {
    if (value) link.setAttribute(key, value);
  });
  return link;
};

const StorefrontFavicon = ({ storefrontSettings, company }) => {
  useEffect(() => {
    const customFavicon = getStorefrontFaviconUrl(storefrontSettings, company);

    upsertIcon('link[rel="icon"][sizes="48x48"]', {
      rel: 'icon',
      type: 'image/png',
      sizes: '48x48',
      href: GOOGLE_FAVICON
    });

    if (customFavicon && customFavicon !== GOOGLE_FAVICON) {
      upsertIcon('link[data-storefront-favicon="true"]', {
        rel: 'icon',
        'data-storefront-favicon': 'true',
        href: customFavicon
      });
    }
  }, [storefrontSettings, company]);

  return null;
};

export default StorefrontFavicon;
